<template>
  <div style="margin-top:-10px !important">
    <b-row class="px-pad border-bottom" style="height:42px">
      <b-col md="6" xl="6" lg="6" sm="6" xs="6" cols="6" class="px-0">
        <span class="fw-semi-bold index-heading pl-0">Email Statement</span>
      </b-col>

      <!-- To get create modal -->
      <b-col md="6" lg="6" sm="6" cols="6" class="text-right px-0">
        <a @click="$emit('redirectPage')">
          <i class="la la-remove la-lg text-decoration-none pt-2 mt-1"></i>
        </a>
      </b-col>
    </b-row>
    <b-row class="mt-2 px-pad">
      <b-col xl="12" lg="12" md="12" xs="12" sm="12" class="px-0">
        <div class="container-fluid">
          <b-alert class="alert-transparent alert-danger" :show="duplicatecode">
            <p class="fw-semi-bold">{{ message }}</p>
          </b-alert>
          <b-alert class="alert-transparent alert-danger" :show="error_show && this.errors.any()">
            <button type="button" @click="error_show=!error_show" class="close">
              <span aria-hidden="true">&times;</span>
            </button>
            <div v-for="item in errors.items" :key="item.id" v-if="item.scope=='email-form'">
              <p class="fw-semi-bold">{{ item.msg }}</p>
            </div>
          </b-alert>
        </div>
      </b-col>
    </b-row>
    <b-form
      method="post"
      @submit.prevent="onSubmit('email-form')"
      data-vv-scope="email-form"
      class="mt-3 pt-1"
      style="max-width:1000px;margin-left:3px;margin-right:3px"
    >
      <b-row class="pt-2">
        <!-- Mail from address -->
        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
          <b-form-group
            horizontal
            :label-cols="2"
            :label-class=" 'required'"
            label="Template Name"
            label-for="name"
          >
            <b-form-input
              id="name"
              type="text"
              size="sm"
              data-vv-name="template name"
              v-model.trim="field.name"
              v-validate="'max:100|required'"
              name="name"
              placeholder
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="pt-2">
        <!-- Mail from address -->
        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
          <b-form-group
            horizontal
            :label-cols="2"
            label="From"
            label-for="from_address"
            :label-class=" 'required'"
          >
            <b-form-input
              id="from_address"
              type="text"
              data-vv-name="from address"
              size="sm"
              v-model.trim="field.from_address"
              v-validate="'required|email'"
              name="from_address"
              placeholder
            />
          </b-form-group>
        </b-col>
      </b-row>
      <!-- Mail to address -->

      <b-row class="pt-2">
        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
          <b-form-group horizontal :label-cols="2" label="Cc" label-for="Cc">
            <vue-tags-input
              placeholder="Add Cc"
              class="input_width"
              :tags="field.cc_me.name"
              @tags-changed="newTags => field.cc_me.name = newTags"
              v-model.trim="field.cc_me.label"
              @before-adding-tag="checkTag"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="pt-2">
        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
          <b-form-group horizontal :label-cols="2" label="Bcc" label-for="Bcc">
            <vue-tags-input
              placeholder="Add Bcc"
              class="input_width"
              :tags="field.bcc_me.name"
              @tags-changed="newTags => field.bcc_me.name = newTags"
              v-model.trim="field.bcc_me.label"
              @before-adding-tag="checkTag"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="pt-2">
        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
          <b-form-group horizontal :label-cols="2" label="Subject" label-for="sub">
            <b-form-input
              id="sub"
              type="text"
              size="sm"
              v-model.trim="field.subject"
              name="subject"
              v-validate="'max:100'"
              placeholder
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="pt-2">
        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
          <b-form-group horizontal :label-cols="2" label-for="sub">
            <trumbowyg v-model="field.body"></trumbowyg>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="py-4">
        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
          <b-form-group horizontal :label-cols="2" label-for="sub">
            <b-form-checkbox
              :disabled="is_default==1"
              v-model="field.is_default"
              value="1"
              unchecked-value="0"
            >Set this to Default</b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <div class="footer" style="box-shadow:0 -4px 5px -3px #ccc;">
        <div class="form-action" style="background:none !important;margin:0px;">
          <b-button
            type="submit"
            size="sm"
            variant="primary"
            class="btn-rounded mr-3"
            :disabled="submitted"
          >
            <i v-if="submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i>
            {{ $route.params.id ? 'Update' : 'Save' }}
          </b-button>
        </div>
      </div>
    </b-form>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import $ from "jquery"; // for using jquery function
import vSelect from "vue-select"; // vue seatch select component
import trumbowyg from "vue-trumbowyg";
import VueTagsInput from "@johmun/vue-tags-input";
export default {
  name: "Email",

  components: {
    VueTagsInput,
    vSelect,
    trumbowyg
  },
  props: ["submitted", "duplicatecode"],
  data() {
    return {
      show_bcc: "",
      error_show: false,
      field: this.createFreshEventObject(),
      is_default: 0
    };
  },
  created() {
    this.field.from_address = this.org_details.org_mail;
    if (this.$route.params.id || this.$route.query.clone_id) {
      this.field.name = this.list.name;
      this.field.subject = this.list.subject;
      this.field.is_default = this.$route.query.clone_id
        ? 0
        : this.list.is_default;
      this.is_default = this.$route.params.id ? this.list.is_default : 0;
      this.field.app_menu = this.list.app_menu;
      this.field.body = this.list.body.body;
      this.field.template_id = this.list.template_id;
      this.field.bcc_me = this.list.body.bcc_me;
      this.field.cc_me = this.list.body.cc_me;
      this.field.from_address =
        this.list.body.from_address == ""
          ? this.org_details.org_mail
          : this.list.body.from_address;
    }
  },
  methods: {
    checkTag(obj) {
      if (obj.tag.text.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/)) {
        obj.addTag();
      } else {
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: "Enter valid email address",
          type: "danger",
          showCloseButton: true
        });
      }
    },

    // to refresh the fields as empty
    createFreshEventObject() {
      return {
        template_id: "",
        from_address: "",
        bcc_me: {
          value: "",
          label: "",
          name: []
        },
        cc_me: {
          value: "",
          label: "",
          name: []
        },
        subject: "",
        body: "",
        is_default: 0,
        name: ""
      };
    },
    onSubmit(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          //  send the json data
          var data = JSON.stringify({
            template_id: this.field.template_id,
            template_content: this.field,
            template_name: this.field.name,
            app_menu: this.$route.query.tns_type,
            is_default: this.field.is_default,
            template_subject: this.field.subject
          });
          this.$emit("onSubmit", {
            data: data
          });
        } else {
          // Scroll to error message show
          var content = $(".container-fluid");
          content[0].scrollIntoView(false);
          this.error_show = true; // validate the form if fail
          this.submitted = false;
        }
      });
      return false;
    }
  },
  computed: {
    ...mapState({
      list: state => state.settings.list,
      message: state => state.settings.message
    }),
    ...mapGetters(["org_details"])
  }
};
</script>
<style scoped>
.vue-tags-input {
  max-width: 100% !important;
}
.ti-input {
  border-radius: 3px !important;
}
.attach {
  width: 200px !important;
  border-radius: 0px !important;
  border-top: 1px dashed #dddddd !important;
  border-bottom: 1px dashed #dddddd !important;
  border-right: 1px dashed #dddddd !important;
}
.input-group-text {
  border-right: none !important;
}
</style>
